<template>
  <main-container>
    <common-header/>
    <section-heading>&nbsp;</section-heading>
    <contents-container>
      <template v-if="rescuePattern === 1">
        <contents-text>修理補償の申請を進める場合はこちら</contents-text>
        <button-container>
          <button-main variant="primary" @click="next">修理補償申請画面</button-main>
        </button-container>
      </template>
      <template v-else-if="rescuePattern === 2">
        <contents-text>お客さまのご利用端末は修理代金サポート（保険）の補償対象です。<br>保険金請求を進める場合はこちら</contents-text>
        <button-container>
          <button-main variant="primary" href="https://pass.auone.jp/anshin/service/hoken/">保険金請求画面</button-main>
        </button-container>
      </template>
      <template v-else-if="rescuePattern === 3">
        <contents-text>お客さまのご利用端末は修理代金サポート（保険）の端末情報事前登録が必要です。<br>端末情報事前登録がお済みの場合には以下より保険金請求をしてください。</contents-text>
        <button-container>
          <button-main :to="{name: 'rep030', query: {p: this.$route.query.p}}">端末情報一覧ページへ</button-main>
        </button-container>
      </template>
      <common-support/>
    </contents-container>
    <common-footer/>
  </main-container>
</template>

<script>
import CommonHeader from '../components/common/CommonHeader'
import CommonFooter from '../components/common/CommonFooter'
import CommonSupport from '../components/common/CommonSupport'
import MainContainer from '../components/container/MainContainer'
import ContentsContainer from '../components/container/ContentsContainer'
import SectionHeading from '../components/heading/SectionHeading'
import ContentsText from '../components/text/ContentsText'
import ButtonContainer from '../components/button/ButtonContainer'
import ButtonMain from '../components/button/ButtonMain'

import ErrorMixin from "../components/mixin/ErrorMixin";
import {postClaimPatternApi} from '../utils/ApiHelper'

export default {
  name: "rep190",
  components: {
    CommonHeader,
    CommonFooter,
    CommonSupport,
    MainContainer,
    ContentsContainer,
    SectionHeading,
    ContentsText,
    ButtonContainer,
    ButtonMain
  },
  mixins: [ErrorMixin],
  data () {
    return {
      isLoading: false,
      form: this.$store.getters.getClaimPattern
    }
  },
  computed: {
    //rescuePattern
    // 1：保険 → 修理/紛失、修理、スマパス2年限定
    // 2：修理 → 保険（免責なし）
    // 3：修理、保険 → 保険事前申請
    rescuePattern() {
      return this.$store.getters.getRescuePattern
    }
  },
  methods: {
    next () {
      if (this.isLoading) return false
      this.isLoading = true

      const repairReferrerInfo = '2'
      let claimPattern = {...this.form, referrerInfo: Number(repairReferrerInfo)}
      postClaimPatternApi(claimPattern)
      .then(res => {
        const result = res.data.result
        if (!this.$_isError(result)) {
          if ('messages' in result) {
            this.$store.dispatch('setErrorMessage', result.messages[0].message)
            this.$router.push({name: result.messages[0].pageId, query: {'p': repairReferrerInfo}})
          } else if ('rescuePattern' in result) {
            this.$store.dispatch('setRescuePattern', result.rescuePattern)
            this.$store.dispatch('setCarrierType', result.carrierType)
            this.$router.push({name: 'rep190', query: {'p': repairReferrerInfo}})
          } else {
            let claimInit = {
              tel: this.form.tel,
              isUpdate: false,
              pageId: result.pageId,
              isAnotherTel: this.form.isAnotherTel
            }
            this.$store.dispatch('setClaimInit', claimInit)
            this.$store.dispatch('setCarrierType', result.carrierType)
            this.$router.push({name: result.pageId, query: {'p': repairReferrerInfo}})
          }
        }
        this.isLoading = false
      })
      .catch(() => {
        this.$router.push({name: 'rep320', query: {'p': repairReferrerInfo}})
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
